"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsernameAuthForm = UsernameAuthForm;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _InputField = require("../InputField");
var _FormFieldHelper = require("../FormFieldHelper");
var _PasswordField = require("../PasswordField");
var _PhoneField = require("../PhoneField");
var _Link = require("../Link");
var _FieldGroupLayout = require("../FieldGroupLayout");
var _flow = require("../../types/flow");
var _keyCodes = require("../../types/keyCodes");
var styles = _interopRequireWildcard(require("./styles.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function UsernameAuthForm(props) {
  const {
    handleSubmit
  } = props;
  const handlePreventSubmit = React.useCallback(e => {
    e.preventDefault();
  }, []);
  const handleSubmitOnEnter = React.useCallback(e => {
    if (e.keyCode === _keyCodes.EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handlePreventSubmit
  }, /*#__PURE__*/React.createElement(_FieldGroupLayout.FormFieldGroupLayout, {
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_InputField.InputField, {
      "data-name": "EmailIdInput",
      name: "username",
      id: "username",
      autoComplete: "off",
      autoFocus: !props.autoFocusDisabled,
      disabled: props.isSubmitting,
      value: props.login,
      required: props.activeFlow === _flow.EActiveFlow.Registration,
      ref: props.loginRef,
      invalid: props.isLoginInvalid,
      errorMessage: props.loginError,
      onKeyDown: handleSubmitOnEnter,
      onChange: props.onLoginChange,
      type: "text",
      placeholder: "Email \u0438\u043B\u0438 id"
    }), /*#__PURE__*/React.createElement(_PasswordField.PasswordField, {
      name: "password",
      id: "password",
      hidden: props.activeFlow === null,
      tabIndex: props.activeFlow === null ? -1 : 0,
      placeholder: "\u041F\u0430\u0440\u043E\u043B\u044C",
      autoComplete: props.activeFlow === _flow.EActiveFlow.Registration ? 'new-password' : 'current-password',
      value: props.password,
      required: props.activeFlow === _flow.EActiveFlow.Registration,
      ref: props.passwordRef,
      invalid: props.isPasswordInvalid,
      disabled: props.isSubmitting,
      onChange: props.onPasswordChange,
      onKeyDown: handleSubmitOnEnter,
      errorMessage: props.passwordError,
      passwordShown: props.passwordShown,
      toggleVisibility: props.togglePasswordVisibility
    }), props.activeFlow === _flow.EActiveFlow.Authentication && /*#__PURE__*/React.createElement(_FormFieldHelper.FormFieldHelper, {
      alignment: _FormFieldHelper.EAlignment.Right,
      marginBottom: true
    }, /*#__PURE__*/React.createElement(_Link.Link, {
      href: "#",
      onClick: props.onResetLinkClick,
      dataMark: "RemindPasswordLink"
    }, "\u0417\u0430\u0431\u044B\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?")), props.activeFlow === _flow.EActiveFlow.Registration && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_PhoneField.PhoneField, {
      id: "tel",
      name: "tel",
      autoComplete: "tel",
      placeholder: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
      value: props.phone,
      inputRef: props.phoneRef,
      invalid: props.isPhoneInvalid,
      disabled: props.isSubmitting,
      onValueChange: props.onPhoneChange,
      onKeyDown: handleSubmitOnEnter,
      errorMessage: props.phoneError
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['checkboxes_row']
    }, /*#__PURE__*/React.createElement(_FormFieldHelper.FormFieldHelper, null, /*#__PURE__*/React.createElement("div", {
      className: styles['professional_row']
    }, /*#__PURE__*/React.createElement(_uiKit.Checkbox, {
      label: "\u042F \u2013 \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B",
      checked: props.isProfessionalUser,
      onChange: props.onProfessionalUserChange
    }), /*#__PURE__*/React.createElement("span", {
      className: styles['professional_info']
    }, /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 17 17",
      width: "17",
      height: "17"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M8.4 0C3.7.1-.1 3.9 0 8.6.1 13.3 3.9 17 8.6 17c4.7-.1 8.4-3.9 8.4-8.6-.1-4.7-3.9-8.5-8.6-8.4zm0 13.7c-.8 0-1.3-.6-1.3-1.3 0-.7.5-1.2 1.2-1.2s1.2.5 1.2 1.3c.1.7-.4 1.2-1.1 1.2zm3-6.1c-.2.2-.5.5-1 .9l-.5.4c-.3.2-.5.4-.6.6-.1.2-.1.2-.1.5v.1h-2v-.2c0-.7 0-1.1.3-1.4.6-.5 1.6-1.1 1.6-1.1.1-.1.3-.3.3-.4.2-.3.3-.5.3-.7 0-.3-.1-.6-.3-.8-.1-.3-.4-.4-.9-.4s-.8.2-1 .5c-.2.3-.3.6-.3 1v.1h-2v-.1c.1-1.3.5-2.2 1.3-2.7.5-.4 1.2-.6 1.9-.6 1 0 1.8.2 2.5.7.7.5 1 1.2 1 2.1 0 .6-.2 1.1-.5 1.5z"
    })), /*#__PURE__*/React.createElement("div", {
      className: styles['professional_info_tooltip']
    }, /*#__PURE__*/React.createElement("p", null, "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0442\u043C\u0435\u0442\u044C\u0442\u0435, \u0435\u0441\u043B\u0438 \u0432\u044B", /*#__PURE__*/React.createElement("br", null), "\u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0438\u044D\u043B\u0442\u043E\u0440,", /*#__PURE__*/React.createElement("br", null), "\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0435\u043B\u044C \u0430\u0433\u0435\u043D\u0442\u0441\u0442\u0432\u0430 \u0438\u043B\u0438 \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A.")))))))),
    buttons: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "ContinueAuthBtn",
      loading: props.isSubmitting,
      onClick: handleSubmit,
      fullWidth: true
    }, props.submitButtonText), props.activeFlow === null && /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "SwitchToPhoneAuthBtn",
      theme: "fill_secondary",
      onClick: props.onSwitchAuthByPhone,
      fullWidth: true
    }, "\u0412\u043E\u0439\u0442\u0438 \u043F\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443"))
  }));
}